import { helpers } from "vuelidate/lib/validators";
import moment from "moment";
import { resolvePropertyByString } from "./Object";
import { resolveInDateRageOptions } from "./Datepicker"

const BASE_API_URL = process.env.VUE_APP_API_SERVER;

export default {
    /**
     *
     * @param value
     * @returns {boolean}
     */
    date: value =>
        !helpers.req(value) || moment(value, "MM/DD/YYYY", true).isValid(),
    expDate: value => {
        const lastMonth = moment().subtract(1, 'months');
        return !helpers.req(value) || (moment(value, "MM/YY", true).isValid() && moment(value, "MM/YY", true).isAfter(lastMonth, "month"))
    },
    phone: value => !helpers.req(value) || /^\(\d{3}\) \d{3}-\d{4}$/.test(value),
    zip: value => !helpers.req(value) || /^\d{5}(-\d{4})?$/.test(value),
    minimumAge: minAge => value =>
        moment(value, "MM/DD/YYYY", true).isValid() &&
        moment().diff(value, "years", false) >= minAge,
    poBox: value =>
        /(((p[\s\.]?[o\s][\.]?)\s?)|(post\s?office\s?))((box|bin|b\.?)?\s?(num|number|#)?\s?\d+)/i.test(
            value
        ),
    noPoBox: value =>
        !/(((p[\s\.]?[o\s][\.]?)\s?)|(post\s?office\s?))((box|bin|b\.?)?\s?(num|number|#)?\s?\d+)/i.test(
            value
        ),
    houseNumber: value => /^\d/.test(value),
    minMoney: (minVal, store) => value => {
        if (Number(value.replace(/\$|,/g, "")) == 0)
            return false;

        if (typeof minVal === "object") {

            return Number(value.replace(/\$|,/g, "")) >= resolvePropertyByString(store.state, minVal.store);
        }
        return Number(value.replace(/\$|,/g, "")) >= minVal;
    },
    maxMoney: (maxVal, store) => value => {
        if (typeof maxVal === "object") {
            return Number(value.replace(/\$|,/g, "")) <= resolvePropertyByString(store.state, maxVal.store);
        }
        return Number(value.replace(/\$|,/g, "")) <= maxVal;
    },
    regex: (validator, store) => value => {
        let regex;
        if (typeof validator === "object") {
            if (store.state.hasOwnProperty(validator.store) && store.state[validator.store]) {
                regex = store.state[validator.store];
            } else {
                return true;
            }
        } else if (typeof validator === "string") {
            regex = validator;
        } else {
            return true;
        }
        return new RegExp(regex).test(value);
    },
    ssn: value => {
        // strip out any non-numbers
        value = value.replace(/[^0-9]/g, "");
        let Section1 = value.substring(0, 3);
        let Section2 = value.substring(3, 5);
        //console.log(process.env);
        // 1st 3 digits can't be 666 and no section can be all zeroes
        if (Section1 == 666 || Section1 == 0 || Section2 == 0 || value.substring(5, 9) == "0000") {
            return false;
        }

        // is ITIN instead of SSN
        if (Section1 >= 900) {
            // Section2 must be between 70-88 or 90-92 or 94-99
            if (Section2 == 89 || Section2 == 93 || Section2 < 70) {
                return false;
            }
        }

        let ascending = "^($|^(012345678)$|^(123456789)$|^(234567890)$)$";
        let regexAscending = new RegExp(ascending);

        // can't be ascending digits starting from 0, 1, or 2
        if (regexAscending.test(value)) {
            return false;
        }

        let cantBe123 = "^(^(^(12345)\d)$|^(123123)$|^(0{6}|1{6}|2{6}|3{6}|4{6}|5{6}|6{6}|7{6}|8{6}|9{6})$)$";
        let regexcantBe123 = new RegExp(cantBe123);
        // 1st 5 digits can't be 12345
        // 1st 6 digits can't be 123123
        // 1st 6 digits cannot be same
        if (regexcantBe123.test(value.substring(0, 6))) {
            return false;
        }

        return true;
    },
    ssnPopulated: (store) => (value) => {
        const oldSSN = store.getters.integratedData.userSSN.split('-').join('');
        const newSSN = value.split('-').join('');
        const isProcessing = store.getters.validatingCust;

        if (oldSSN !== newSSN && newSSN.length === 9 && !isProcessing) {
            return store.dispatch("validateExistingCustomer");
        }
        else {
            return () => { };
        }
    },
    maxNumLength: maxLength => value => {
        return value.toString().length <= maxLength;

    },
    minNumLength: minLength => value => {
        return value.toString().length >= minLength;

    },
    inDateRange: range => value => {
        const resolvedOptions = resolveInDateRageOptions(range);
        const start = resolvedOptions.start;
        const end = resolvedOptions.end;
        return moment(value, "MM/DD/YYYY", true).isBetween(start, end, "day", "(]");
    },
    creditOrDebitCard: (store) => value => {
        return store.dispatch("isCardNumberValid", value);
    },
    bankNamePopulated: (store) => value => {
        return store.dispatch("setBankName", value);
    },
    fullNameLimit: (maxVal, store) => value => {
        var frm = store.state.formValues.basic;
        var result = maxVal >= (frm.firstName.length + frm.middleInitial.length + frm.lastName.length);

        return result;
    },
    alphaWithDash: (value) => (/[a-z|\s|\.|\-]/i.test(value)),
    excludeTsysAccountId: value => {
        const accountNumber = value;
        const firstSevenCharacters = accountNumber.substring(0, 7);
        const containsTsysAccountIdValues = firstSevenCharacters.includes('5877891') && accountNumber.length == 16;
        return !containsTsysAccountIdValues;
    },
};
